import { useAppUpdatePromptStore } from "@/domains/shared/appUpdatePrompt/appUpdatePromptStore";
import { isMeaningfulClickTarget } from "@/domains/shared/appUpdatePrompt/isMeaningfulClick";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router";

/**
 * Soft triggers: route change + meaningful clicks when update is known (FR-04).
 */
export function useAppUpdateSoftTriggers(): void {
  const location = useLocation();
  const notifySoftTrigger = useAppUpdatePromptStore((s) => s.notifySoftTrigger);
  const isFirstRoute = useRef(true);
  const lastPathRef = useRef(`${location.pathname}${location.search}${location.hash}`);

  useEffect(() => {
    const key = `${location.pathname}${location.search}${location.hash}`;
    if (isFirstRoute.current) {
      isFirstRoute.current = false;
      lastPathRef.current = key;
      return;
    }

    if (key === lastPathRef.current) {
      return;
    }

    lastPathRef.current = key;
    notifySoftTrigger();
  }, [location.pathname, location.search, location.hash, notifySoftTrigger]);

  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      if (event.defaultPrevented || event.button !== 0) {
        return;
      }

      if (!isMeaningfulClickTarget(event.target)) {
        return;
      }

      notifySoftTrigger();
    };

    document.addEventListener("click", onClick, true);
    return () => {
      document.removeEventListener("click", onClick, true);
    };
  }, [notifySoftTrigger]);
}
